import useQueryParamString from './useQueryParamString'

/**
 * @returns The edit mode value, used in conjunction with edit mode, and a function to set it.
 */
export default function useEditValue(): [string | undefined, (value?: string) => void] {
  return useQueryParamString('editValue', undefined)
}
